// ============================================
// SHOPIFY FREE GIFT CONFIGURATION (COMPLETE DROP-IN)
// ============================================

// 1) Ensure Shopify namespace
if (typeof Shopify === 'undefined') {
  Shopify = {};
}

// 2) Error handlers
Shopify.onError = function(xhr, status) {
  try {
    var err = JSON.parse(xhr.responseText);
    if (err.message) {
      alert(err.message + " (" + xhr.status + "): " + err.description);
    } else {
      alert("Error: " + Shopify.fullMessagesFromErrors(err).join("; ") + ".");
    }
  } catch (e) {
    console.error("Error parsing JSON response:", e, xhr.responseText);
    alert("An unexpected error occurred. Please try again.");
  }
};
Shopify.fullMessagesFromErrors = function(errors) {
  var msgs = [];
  jQuery.each(errors, function(field, arr) {
    jQuery.each(arr, function(_, m) { msgs.push(field + " " + m); });
  });
  return msgs;
};

// 3) Currency formatting fix (for GBP stores)
$(function() {
  if (
    Shopify.currency &&
    Shopify.currency.active === 'GBP' &&
    Shopify.money_format.indexOf('£') === -1
  ) {
    Shopify.money_format = '£{{amount}}';
  }
});

// ----------------------------------
// AJAX CART HELPERS (unchanged)
// ----------------------------------

Shopify.addItem = function(items, callback) {
  items = Array.isArray(items) ? { items } : { items: [items] };
  items.items.forEach(i => (i.quantity = i.quantity || 1));

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: items,
    dataType: "json",
    success: function(res) {
      Shopify.onItemAdded(res.items);
      res.items.forEach((item, idx) => {
        setTimeout(function() {
          notifyCustomer(item.url + ".js", item.variant_id, item.quantity);
        }, idx * 500);
      });
      if (typeof callback === "function") callback(res);
    },
    error: Shopify.onError
  });
};

Shopify.onItemAdded = function(items) {
  items.forEach(i => console.log(i.title + " added to cart."));
  Shopify.getCart();
};

Shopify.getCart = function(callback) {
  jQuery.getJSON("/cart.js", function(cart) {
    if (typeof callback === "function") {
      callback(cart);
    } else {
      Shopify.onCartUpdate(cart);
      document.querySelector(".cart__item-count").innerText = cart.item_count;
      mobile_menu.rebuildCartLineOrder(cart.items);
    }
  });
};

Shopify.changeItem = function(id, qty, key, cb) {
  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=" + qty + "&" + key + "=" + id,
    dataType: "json",
    success: function(res) {
      (typeof cb === "function") ? cb(res) : Shopify.onCartUpdate(res);
    },
    error: Shopify.onError
  });
};

Shopify.removeItem = function(id, key, cb) {
  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=0&" + key + "=" + id,
    dataType: "json",
    success: function(res) {
      (typeof cb === "function") ? cb(res) : Shopify.onCartUpdate(res);
    },
    error: Shopify.onError
  });
};

Shopify.updateItem = function(updates, cb) {
  jQuery.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: { updates },
    dataType: "json",
    success: function(res) {
      (typeof cb === "function") ? cb(res) : Shopify.onCartUpdate(res);
    },
    error: Shopify.onError
  });
};

Shopify.queue = [];
Shopify.moveAlong = function() {
  if (Shopify.queue.length) {
    var req = Shopify.queue.shift();
    Shopify.addItem(
      { id: req.variantId, quantity: req.quantity, properties: req.properties },
      Shopify.moveAlong
    );
  }
};
function push_to_queue(id, qty, props, cb) {
  Shopify.queue.push(
    props
      ? { variantId: id, quantity: qty, properties: props }
      : { variantId: id, quantity: qty }
  );
  if (typeof cb === "function") cb();
}

// ----------------------------------
// FREE-GIFT PROGRESS BAR & TOOLTIP
// ----------------------------------

Shopify.onCartUpdate = function(cart) {
  $(".cart__item-count").text(cart.item_count);
  $(".total-price").text(Shopify.formatMoney(cart.total_price));
  $(".free-gift__current-price").text(Shopify.formatMoney(cart.total_price));

  (function updateFreeGiftUI() {
    // ———— drop the $1 (100¢) tier ————
    var prices = [3000, 3500, 5000, 10000, 15000];
    var labels = [
      'FREE Shipping',
      'a FREE MŌDA® Limited Edition Rose Shadow',
      'a FREE MŌDA® Metallics 2pc Ultimate Eye Sculptors',
      'a FREE MŌDA® Angled Kabuki & Magic Sponge',
      'a FREE MŌDA® Check Me Out, Purple & Pink 5pc Kit'
    ];
    var images = Array(prices.length).fill(
      'https://cdn.shopify.com/s/files/1/0561/0261/files/FreeGift_Image_2_700x.jpg?v=1605109132'
    );

    clearTimeout(checkFreeGiftsTimer);
    checkFreeGiftsTimer = setTimeout(() => Shopify.getCart(checkFreeGifts), 500);

    if (cart.items.length === 0) {
      document.querySelector(".cart-items").innerHTML =
        "<h2 style='text-align:center;'>You have no items in your cart</h2>";
      return;
    }

    // how many tiers met?
    var count = 0;
    prices.forEach((th, i) => {
      if (cart.total_price >= th) count = i + 1;
    });

    // update progress bar
    var pct = count === prices.length
      ? 100
      : (cart.total_price / prices[count]) * 100;
    var remaining = prices[count] - cart.total_price;
    document.querySelector(".progress-bar").style.width = pct + "%";

    // show message & image
    if (count === prices.length) {
      document.querySelector(".cart-freegifts__add-more").innerHTML =
        "<p>Your cart qualifies for all of our free gifts.</p>";
      document.querySelector(".free-gift-display").src = images[prices.length - 1];
    } else {
      document.querySelector(".cart-freegifts__add-more").innerHTML =
        "<p>Add " +
        Shopify.formatMoney(remaining) +
        " more and receive " +
        labels[count] +
        "</p>";
      document.querySelector(".free-gift-display").src = images[count];
    }

    // build tooltip list
    var tt = document.querySelector(".tooltip-qualifying-gifts");
    document.querySelector(".tooltip-heading").innerText =
      count === 0
        ? "Your order doesn't qualify for any gifts yet."
        : "Your cart qualifies for:";
    tt.innerHTML = "";
    for (var i = 0; i < count; i++) {
      var li = document.createElement("li");
      li.className = "free-gift-item";
      li.innerText = labels[i];
      tt.appendChild(li);
    }
  })();
};

// ----------------------------------
// FREE-GIFT LOGIC (line-items only)
// ----------------------------------

var freeGifts = [
  { id: 37531743420586, sku: "BMD-GIVE",    maxQty: 1, qualifier: { minCartValue: 3500 } },
  {
    id: 37542452330666, sku: "BMD-PROMO1", maxQty: 1,
    qualifier: {
      minCartValue: 5000,
      timeframe: {
        startDate: "2022-03-17 00:00:00 -0500",
        endDate:   "2026-03-22 02:00:00 -0500"
      }
    }
  },
  { id: 37531778154666, sku: "BMD-GIVE100", maxQty: 1, qualifier: { minCartValue: 10000 } },
  { id: 41572429398186, sku: "BMD-PROMO2",   maxQty: 1, qualifier: { minCartValue: 15000 } }
];

/* ============================================================
   FIX: Define withinTimeframe HERE so it's available when
   checkFreeGifts runs. Previously it only existed in
   shop.js.liquid which loads AFTER this file, causing:
   "Uncaught ReferenceError: withinTimeframe is not defined"
   on every single page load.
   ============================================================ */
function withinTimeframe(startDate, endDate) {
  var currentDate = Date.now();
  if (typeof startDate === "string") {
    startDate = new Date(startDate).getTime();
  }
  if (typeof endDate === "string") {
    endDate = new Date(endDate).getTime();
  }
  return (startDate <= currentDate && currentDate <= endDate);
}

var checkFreeGiftsTimer;
function checkFreeGifts(cart) {
  var toAdd    = [],
      toRemove = {};

  freeGifts.forEach(function(gift) {
    var inCart    = false,
        qualifies = true;

    // timeframe?
    if (gift.qualifier.timeframe) {
      qualifies = withinTimeframe(
        gift.qualifier.timeframe.startDate,
        gift.qualifier.timeframe.endDate
      );
    }

    // scan existing line items
    cart.items.forEach(function(item) {
      if (item.id === gift.id) inCart = true;
      if (gift.qualifier.productSku) {
        qualifies = Array.isArray(gift.qualifier.productSku)
          ? gift.qualifier.productSku.every(sku => item.sku.includes(sku))
          : item.sku.includes(gift.qualifier.productSku);
      }
    });

    // minCartValue?
    if (gift.qualifier.minCartValue !== undefined) {
      if (cart.total_price >= gift.qualifier.minCartValue && !inCart && qualifies) {
        toAdd.push({ id: gift.id, quantity: 1 });
      } else if (cart.total_price < gift.qualifier.minCartValue && inCart) {
        toRemove[gift.id] = 0;
      }
    }
  });

  if (Object.keys(toRemove).length) {
    Shopify.updateItem(toRemove);
  } else if (toAdd.length) {
    Shopify.addItem(toAdd);
  } else {
    mobile_menu.rebuildCartLineOrder(cart.items);
  }

  stopLoader();
}

// ---------------
// INITIAL TRIGGER
// ---------------
Shopify.getCart(checkFreeGifts);
